<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Labour"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        劳动用工管理
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="labourParticulars" v-if="typeShow">
        <h4 class="labourParticulars-title labourParticulars-hw-size">变更类型</h4>
        <p>1. 合同性质变更</p>
        <span>包括全日制劳动合同、非全日制劳动合同及劳务合同。</span>
        
        <p>2. 合同内容变更</p>
        <span>包括岗位变动、部门变动等。</span>
    </div>
    <div class="labourParticulars" v-if="flowShow">
        <h4 class="labourParticulars-title labourParticulars-hw-size">变更流程</h4>
        <p>1. 合同性质变更</p>
        <span>先由申请人发送申请邮件给直属主管，确定具体合同性质，同时抄送王学军（wangxuejun）、薛宇婷（xueyuting3）；再由直属主管向部门总监及人力资源总监报批；部门总监及人力资源总监审批通过后，人力资源部将发出办理合同变更的通知。</span>
        <p>2. 合同内容变更</p>
        <span>于新东方全职工作的应届毕业生，可签署三方协议。先由申请人发送申请邮件（正文写明要求即可）给直属主管，同时抄送王君爽（wangjunshuang），再由直属主管向部门总监及人力资源总监报批；部门总监及人力资源总监通过后，人力资源部将发出统一签署三方协议的通知。</span>
    </div>
    <div class="labourParticulars" v-if="agreementShow">
        <h4 class="labourParticulars-title labourParticulars-hw labourParticulars-hw-size">三方协议签订流程</h4>
        <span>于新东方全职工作的应届毕业生，可签署三方协议。先由申请人发送申请邮件（正文写明要求即可）给直属主管，同时抄送王君爽（wangjunshuang），再由直属主管向部门总监及人力资源总监报批；部门总监及人力资源总监通过后，人力资源部将发出统一签署三方协议的通知。</span>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return {
            typeShow: false,
            flowShow: false,
            agreementShow: false
        }
    },
    methods:{
        fn(){
            var code = this.$route.params.code
            if(code == 89){
                this.typeShow = true
            } else if(code == 99){
                this.flowShow = true
            } else if(code == 79){
                this.agreementShow = true
            }
        },
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"444"}})
        },
    },
    mounted(){
        this.fn()
    }
};
</script>

<style>
.box-labourParticulars {
  width: 100%;
  height: 100%;
  background: rgba(244, 244, 244, 1);
}

.nav {
  width: 100%;
  height: 50px;
  background: #11a093;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  position: relative;
  margin-bottom: 17px;
}

.upClass,
.searchClass {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.upClass {
  width: 12px;
  float: left;
  left: 10px;
}

.searchClass {
  width: 19px;
  float: right;
  right: 10px;
}

.labourParticulars {
  width: 90%;
  height: 83%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
  border-radius: 11px;
  padding-top: 5%;
}
.labourParticulars .labourParticulars-title {
  text-align: center;
  font-weight: 600;
}
.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}
.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
  display: block;
  line-height: 35px;
  margin-left: 16px;
  margin-right: 16px;
  color: #888787;
  font-size: 15px;
  text-indent:30px;
}

.labourParticulars-hw-size {
    font-size: 16px
}
</style>



// WEBPACK FOOTER //
// src/components/Labour/labourParticulars.vue